import React, { useState, useEffect } from 'react';
import Form from 'react-bootstrap/Form';

function EditableLicense ({ name, value, index, onValueChange, path, contentStyle, editStyle, editable}) {
    const [edit, setEdit] = useState(false);
    const [selectedValue, setSelectedValue] = useState(value || '1');

    useEffect(() => {
      if (edit) {
        document.getElementById(`${name}-${index}`).focus();
      }
    }, [edit, name, index]);

    const handleContentClick = (index, content) => {
      if (!editable) return;
      setEdit(true);
      setSelectedValue(content);
    };

    function handleChange(event) {
      setSelectedValue(event.target.value);
      setEdit(false);
      if (onValueChange) onValueChange(path, event.target.value);
    }

    const options = {
      '1': {
        text: 'None/TBD',
        className: ''
      },'2': {
        text: 'CERN OHL v2.0 W',
        className: ''
      },'3': {
        text: 'CERN OHL v2.0 S',
        className: ''
      },'4': {
        text: 'TAPR',
        className: ''
      },'5': {
        text: 'Solderpad Hardware License',
        className: ''
      },'6': {
        text: 'Creative Commons (CC-BY-SA)',
        className: ''
      },'7': {
        text: 'Creative Commons (CC0)',
        className: ''
      },'8': {
        text: 'GPL',
        className: ''
      },'9': {
        text: 'LGPL',
        className: ''
      },'10': {
        text: 'MIT',
        className: ''
      },'11': {
        text: 'BSD',
        className: ''
      },'12': {
        text: 'Apache 2.0',
        className: ''
      },'13': {
        text: 'Other',
        className: ''
      },'14': {
        text: 'None',
        className: ''
      }
    }

     return (
      ((edit && editable) ? (
        <Form.Select
          aria-label={options[selectedValue].text}
          id={`${name}-${index}`}
          key={`${name}-${index}`}
          value={selectedValue} 
          onChange={(e) => handleChange(e, index)}
          onBlur={(e) => handleChange(e, index)}
          style={{width: `11em`, display: 'inline-block', ...editStyle}}
        >
          {Object.entries(options).map(([key, value]) => (
            <option key={key} value={key}>
              {value.text}
            </option>
          ))}
        </Form.Select>
      ) : (
        <div style={{display: 'inline', cursor: editable ? "context-menu" : ""}} id={`difficulty-${name}-${index}`} onClick={() => handleContentClick(index, selectedValue)}>{options[selectedValue].text}</div>
      ))
    );
    /*

     <Form.Select aria-label="Default select example">
      <option>Open this select menu</option>
      <option value="1">One</option>
      <option value="2">Two</option>
      <option value="3">Three</option>
    </Form.Select>

    return (
      (edit ? (
        <input 
          id={`${name}-${index}`}
          key={`${name}-${index}`}
          type="text" 
          value={text} 
          onChange={handleChange} 
          onBlur={(e) => handleEditableBlur(e, index)}
          onKeyPress={(e) => handleKeyPress(e, index)}
          style={{...editStyle}}
        />
      ) : (
        <div style={{cursor: "context-menu"}} id={`editable-${name}-${index}`} onClick={() => handleContentClick(index, text)}>{text}</div>
      ))
    );
    */
}

export default EditableLicense;